import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { SobrePage } from "./pages/SobrePage";
import { EmagrecimentoPage } from "./pages/EmagrecimentoPage";
import { ReposicaoHormonalPage } from "./pages/ReposicaoHormonalPage";
import { ComoFuncionaPage } from "./pages/ComoFuncionaPage";
import { AgendamentoPage } from "./pages/AgendamentoPage";
import { BlogPage } from "./pages/BlogPage";
import { Toaster } from "./components/ui/sonner";
import { WhatsAppWidget } from "./components/WhatsAppWidget";

function App() {
  return (
    <div className="App min-h-screen bg-[#FAF9F7]">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/sobre" element={<SobrePage />} />
          <Route path="/emagrecimento" element={<EmagrecimentoPage />} />
          <Route path="/reposicao-hormonal" element={<ReposicaoHormonalPage />} />
          <Route path="/como-funciona" element={<ComoFuncionaPage />} />
          <Route path="/agendamento" element={<AgendamentoPage />} />
          <Route path="/blog" element={<BlogPage />} />
        </Routes>
        <Footer />
        <WhatsAppWidget />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
